/**
 * @generated SignedSource<<a694c736211c85ebcf3343e94c204614>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignTodoModal_todo$data = {
  readonly assignee: {
    readonly id: string;
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserHandle_member">;
  } | null;
  readonly documentNode: {
    readonly space: {
      readonly id: string;
    };
  };
  readonly id: string;
  readonly " $fragmentType": "AssignTodoModal_todo";
};
export type AssignTodoModal_todo$key = {
  readonly " $data"?: AssignTodoModal_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"AssignTodoModal_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AssignTodoModal_todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FolderItem",
      "kind": "LinkedField",
      "name": "documentNode",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Member",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserHandle_member"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserAvatar_member"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "565d156e78ef2b9fa819931643a0d601";

export default node;
